/**
 * 販売LPに出す章立てと分量。
 *
 * 自動生成。手で直さない。
 *   bun run packages/shared-repositories/scripts/_gen-skills-chapters.ts
 *
 * 元データは practical_chapters テーブル。教材を直したら再実行する。
 */

export type LpChapterEntry = {
  no: number;
  title: string;
  /** 章の冒頭1文。無い章は空文字 */
  text: string;
  /** 教材本文に書いてある所要時間。無い章は空文字 */
  time: string;
};

export type LpVolume = {
  /** 章数 */
  chapters: number;
  /** 本文の文字数 */
  chars: number;
  /** コード例の数 */
  codeBlocks: number;
  /** 教材が示す所要時間の合計（時間） */
  hours: number;
};

export const SKILL_CHAPTERS: Record<string, LpChapterEntry[]> = {
  "ec-site": [
    {
      "no": 1,
      "title": "はじめに",
      "text": "このプロジェクトでは、ECサイトをフルスタックで制作します。",
      "time": "約1.5時間"
    },
    {
      "no": 2,
      "title": "ヒアリング",
      "text": "実務では、開発に入る前にクライアントから要望をヒアリングします。",
      "time": "約1時間"
    },
    {
      "no": 3,
      "title": "企画書を読み解く",
      "text": "実務では、ヒアリング結果を整理し「何を作るか・作らないか」をクライアントと合意するために企画書を作成します。",
      "time": "約1時間"
    },
    {
      "no": 4,
      "title": "要件定義書を読み解く",
      "text": "要件定義書は、企画書の「何を実現したいか」を エンジニアが扱える具体的な要件 に翻訳したドキュメントです。",
      "time": "約1.5時間"
    },
    {
      "no": 5,
      "title": "基本設計書を読み解く",
      "text": "基本設計書は「外部仕様」を決めるドキュメントです。",
      "time": "約2時間"
    },
    {
      "no": 6,
      "title": "詳細設計書を読み解く",
      "text": "詳細設計書は、基本設計の外部仕様を「実装に落とせる粒度」まで具体化したドキュメントです。",
      "time": "約2.5時間"
    },
    {
      "no": 7,
      "title": "実装の進め方",
      "text": "実装フェーズの章は 「Ch7-1」「Ch7-2」… のサブ章番号 で呼びます。",
      "time": "約1時間"
    },
    {
      "no": 8,
      "title": "環境構築",
      "text": "実務でも使われる「クラウド開発環境」を体験してもらうためです。",
      "time": "約3時間"
    },
    {
      "no": 9,
      "title": "DB準備とプロジェクト雛形",
      "text": "Ch7-1 で用意した Codespaces と Neon を使います。",
      "time": "約4時間"
    },
    {
      "no": 10,
      "title": "商品一覧・詳細",
      "text": "SQL 定数や mapRow などの機械的な部分は starter 同梱、ロジックは自分で書く ── という分担です。",
      "time": "約6時間"
    },
    {
      "no": 11,
      "title": "カート機能",
      "text": "DTO や ヘルパーメソッドは starter 同梱、コアロジックは皆さんが書く ── という分担です。",
      "time": "約5時間"
    },
    {
      "no": 12,
      "title": "認証機能",
      "text": "",
      "time": "約8時間"
    },
    {
      "no": 13,
      "title": "レジ・注文確定（トランザクション）",
      "text": "",
      "time": "約6時間"
    },
    {
      "no": 14,
      "title": "マイページ",
      "text": "この章はユーザー認証（Chapter 7-5）が完了している前提で進みます。",
      "time": "約4時間"
    },
    {
      "no": 15,
      "title": "仕上げ（CSS・エラー・セキュリティ）",
      "text": "機能が動くだけでは「実装完了」とは言えません。",
      "time": "約5時間"
    },
    {
      "no": 16,
      "title": "実装FAQ",
      "text": "実装中によく出る症状・対処法のリファレンス。",
      "time": ""
    },
    {
      "no": 17,
      "title": "テストと動作確認",
      "text": "UT[単体テスト] --> IT[統合テスト]。",
      "time": "約4時間"
    },
    {
      "no": 18,
      "title": "用語ミニ辞書",
      "text": "この章は 辞書として使う章 です。",
      "time": "通読不要"
    }
  ],
  "task-app": [
    {
      "no": 1,
      "title": "はじめに",
      "text": "このプロジェクトでは、タスク管理アプリをフルスタック + 認証つき CRUDで制作します。",
      "time": "約1.5 時間"
    },
    {
      "no": 2,
      "title": "ヒアリング",
      "text": "実務では、開発に入る前にクライアントから要望をヒアリングします。",
      "time": "約1 時間"
    },
    {
      "no": 3,
      "title": "企画書を読み解く",
      "text": "実務では、ヒアリング結果を整理し「何を作るか・作らないか」をクライアントと合意するために企画書を作成します。",
      "time": "約 6 時間"
    },
    {
      "no": 4,
      "title": "要件定義書を読み解く",
      "text": "要件定義書は、企画書の「何を実現したいか」を エンジニアが扱える具体的な要件 に翻訳したドキュメントです。",
      "time": "約 1.5 時間"
    },
    {
      "no": 5,
      "title": "基本設計書を読み解く",
      "text": "基本設計書は「外部仕様」を決めるドキュメントです。",
      "time": "約 2 時間"
    },
    {
      "no": 6,
      "title": "詳細設計書を読み解く",
      "text": "詳細設計書は、基本設計の各要素を 実装可能な粒度 まで分解するドキュメントです。",
      "time": "約2.5 時間"
    },
    {
      "no": 7,
      "title": "実装の進め方",
      "text": "ここまでの Chapter 3 〜 6 で、企画書・要件定義・基本設計・詳細設計と上流の成果物を読み解いてきました。",
      "time": "約1時間"
    },
    {
      "no": 8,
      "title": "環境構築 (ローカル + Neon + 雛形起動)",
      "text": "PJ#1 (Java + Tomcat) と違って、本 PJ はフロントとバックエンドの 2 プロセス構成です。",
      "time": "約3 時間"
    },
    {
      "no": 9,
      "title": "Prisma スキーマ定義と migration / seed 投入",
      "text": "PJ#1 (Java + JDBC) ではテーブルを schema.sql という生 DDL で書きました。",
      "time": "約 4 時間"
    },
    {
      "no": 10,
      "title": "認証 API (signup / login / JWT 発行)",
      "text": "POST /api/auth/signup で新規登録、POST /api/auth/login でログインし、レスポンスとして JWT を返します。",
      "time": "約8時間"
    },
    {
      "no": 11,
      "title": "タスク CRUD API (一覧 / 作成 / 更新 / 削除 + 楽観ロック)",
      "text": "",
      "time": "約9 時間"
    },
    {
      "no": 12,
      "title": "Frontend ログイン / 登録画面と JWT 保存",
      "text": "React + React Router で /login /signup / (タスク一覧) の 3 画面を行き来できるようにします。",
      "time": "約 6 時間"
    },
    {
      "no": 13,
      "title": "タスク一覧画面 (Tailwind リスト UI + ステータスフィルタ)",
      "text": "/tasks でログイン済みユーザーのタスクをカード状に並べた画面を作ります。",
      "time": "約7 時間"
    },
    {
      "no": 14,
      "title": "タスクの作成・編集・削除モーダル",
      "text": "この章をやり切ると、次の 5 つができるようになります。",
      "time": "約 6 時間"
    },
    {
      "no": 15,
      "title": "仕上げ（CSS・エラー・セキュリティ・デプロイ）",
      "text": "機能が動くだけでは「実装完了」とは言えません。",
      "time": "約 8 時間"
    },
    {
      "no": 16,
      "title": "実装FAQ",
      "text": "実装中によく出る症状・対処法のリファレンス。",
      "time": ""
    },
    {
      "no": 17,
      "title": "用語ミニ辞書",
      "text": "この章は 辞書として使う章 です。",
      "time": "通読不要"
    }
  ],
  "ai-chat": [
    {
      "no": 1,
      "title": "はじめに",
      "text": "このプロジェクトでは、AI チャットアプリをフルスタック + LLM 連携で制作します。",
      "time": "約1.5 時間"
    },
    {
      "no": 2,
      "title": "ヒアリング",
      "text": "実務では、開発に入る前にクライアントから要望をヒアリングします。",
      "time": "約1 時間"
    },
    {
      "no": 3,
      "title": "企画書を読み解く",
      "text": "実務では、ヒアリング結果を整理し「何を作るか・作らないか」をクライアントと合意するために企画書を作成します。",
      "time": "約 1 時間"
    },
    {
      "no": 4,
      "title": "要件定義書を読み解く",
      "text": "要件定義書は、企画書の「何を実現したいか」を エンジニアが扱える具体的な要件 に翻訳したドキュメントです。",
      "time": "約 1.5 時間"
    },
    {
      "no": 5,
      "title": "基本設計書を読み解く",
      "text": "基本設計書は「外部仕様」を決めるドキュメントです。",
      "time": "約 1.5 時間"
    },
    {
      "no": 6,
      "title": "詳細設計書を読み解く",
      "text": "詳細設計書は、基本設計の各要素を 実装可能な粒度 まで分解するドキュメントです。",
      "time": "約2.5 時間"
    },
    {
      "no": 7,
      "title": "実装の進め方",
      "text": "ここまでの Chapter 3 〜 6 で、企画書・要件定義・基本設計・詳細設計と上流の成果物を読み解いてきました。",
      "time": "約1時間"
    },
    {
      "no": 8,
      "title": "環境構築とリポジトリの起動",
      "text": "",
      "time": "約3 時間"
    },
    {
      "no": 9,
      "title": "API スケルトンとモック応答",
      "text": "ユーザーが送ってきた message を受け取り、ブランドのトーンに合わせた 固定応答 を返す API を組み立てます。",
      "time": "約 5 時間"
    },
    {
      "no": 10,
      "title": "履歴管理とインメモリストア",
      "text": "前章のチャット API はステートレスでしたが、本来 AI チャットは ==過去の文脈を踏まえた応答== が肝です。",
      "time": "約5 時間"
    },
    {
      "no": 11,
      "title": "Frontend チャット UI と API 連携",
      "text": "Vite + React の Frontend に、画面下部の入力欄と、ユーザー / アシスタントの吹き出しを並べたチャット UI を実装します。",
      "time": "約 8 時間"
    },
    {
      "no": 12,
      "title": "OpenAI API への差し替えとプロンプト設計",
      "text": "前章までのモック応答を、本物の OpenAI API 呼び出しに差し替えられるようにします。",
      "time": "約6 時間"
    },
    {
      "no": 13,
      "title": "エラーハンドリングと安全装置",
      "text": "AI チャットは「OpenAI の調子」「ネットワークの揺らぎ」「ユーザーの想定外入力」の三方向からエラーを浴びる宿命があります。",
      "time": "約4 時間"
    },
    {
      "no": 14,
      "title": "モバイル UI とアクセシビリティ調整",
      "text": "Figma のモバイルデザインに合わせて、ヘッダ / メッセージリスト / 入力欄が縦に並んだレイアウトを仕上げます。",
      "time": "約4 時間"
    },
    {
      "no": 15,
      "title": "仕上げ（CSS・エラー・セキュリティ・デプロイ）",
      "text": "機能が動くだけでは「実装完了」とは言えません。",
      "time": "約 8 時間"
    },
    {
      "no": 16,
      "title": "実装FAQ",
      "text": "実装中によく出る症状・対処法のリファレンス。",
      "time": ""
    },
    {
      "no": 17,
      "title": "テストと動作確認",
      "text": "UT[単体テスト] --> IT[統合テスト]。",
      "time": "約 4 時間"
    },
    {
      "no": 18,
      "title": "用語ミニ辞書",
      "text": "この章は 辞書として使う章 です。",
      "time": "通読不要"
    }
  ],
  "bi-dashboard": [
    {
      "no": 1,
      "title": "はじめに",
      "text": "このプロジェクトでは、EC サイト売上分析ダッシュボードをフルスタック分析ダッシュボードで制作します。",
      "time": "約 1.5 時間"
    },
    {
      "no": 2,
      "title": "ヒアリング",
      "text": "実務では、開発に入る前にクライアントから要望をヒアリングします。",
      "time": "約 1 時間"
    },
    {
      "no": 3,
      "title": "提案書を読み解く",
      "text": "実務では、ヒアリング結果を整理し「何を作るか・作らないか」をクライアントと合意するために提案書を作成します。",
      "time": "約 1 時間"
    },
    {
      "no": 4,
      "title": "要件定義書を読み解く",
      "text": "要件定義書は、提案書の「何を実現したいか」を エンジニアが扱える具体的な要件 に翻訳したドキュメントです。",
      "time": "約 2 時間"
    },
    {
      "no": 5,
      "title": "基本設計書を読み解く",
      "text": "基本設計書は「外部仕様」を決めるドキュメントです。",
      "time": "約 2 時間"
    },
    {
      "no": 6,
      "title": "詳細設計書を読み解く",
      "text": "詳細設計書は、基本設計の各要素を 実装可能な粒度 まで分解するドキュメントです。",
      "time": "約 2.5 時間"
    },
    {
      "no": 7,
      "title": "実装の全体像",
      "text": "ここまでの Ch1〜Ch6 で、提案書・要件定義・基本設計・詳細設計と上流の成果物を読み解いてきました。",
      "time": "約 1 時間"
    },
    {
      "no": 8,
      "title": "環境構築 + 認証 API",
      "text": "S1[starter clone] --> S2[DB 用意]。",
      "time": "約 6 時間"
    },
    {
      "no": 9,
      "title": "Prisma スキーマ定義と seed 投入",
      "text": "PJ#1 (Java + JDBC) ではテーブルを schema.sql という生の DDL ファイルで書きました。",
      "time": "約 6 時間"
    },
    {
      "no": 10,
      "title": "KPI 集計 API（/api/dashboard/summary）",
      "text": "本章は PJ#4 ダッシュボードの心臓部 です。",
      "time": "約 6 時間"
    },
    {
      "no": 11,
      "title": "月次売上 API（/api/dashboard/monthly）",
      "text": "指定年の月別売上推移を返す API です。",
      "time": "約 5 時間"
    },
    {
      "no": 12,
      "title": "週次・商品ランキング・カテゴリ集計 API",
      "text": "残り 4 つの API (週次売上・商品売上ランキング・商品注文数ランキング・カテゴリ別売上) を一気に作ります。",
      "time": "約 10 時間"
    },
    {
      "no": 13,
      "title": "KPI カードと Sparkline（React 側）",
      "text": "ダッシュボードのトップページ（/）。",
      "time": "約 8 時間"
    },
    {
      "no": 14,
      "title": "折れ線グラフと売上推移ページ（Recharts）",
      "text": "==売上推移ページ（/sales）== を作ります。",
      "time": "約 8 時間"
    },
    {
      "no": 15,
      "title": "ランキング横棒チャートとカテゴリ円グラフ・仕上げ",
      "text": "ダッシュボードの残り 2 ページを仕上げます。",
      "time": "約 8 時間"
    },
    {
      "no": 16,
      "title": "仕上げ（CSS・エラー・セキュリティ・デプロイ）",
      "text": "機能が動くだけでは「実装完了」とは言えません。",
      "time": "約 8 時間"
    },
    {
      "no": 17,
      "title": "実装 FAQ",
      "text": "実装中によく出る症状・対処法のリファレンス。",
      "time": ""
    },
    {
      "no": 18,
      "title": "テストと動作確認",
      "text": "T1[全 10 ケースのテスト実行] --> T2[セキュリティ最終チェック]。",
      "time": "約 6 時間"
    },
    {
      "no": 19,
      "title": "用語ミニ辞書",
      "text": "この章は 辞書として使う章 です。",
      "time": "通読不要"
    }
  ]
};

export const SKILL_VOLUME: Record<string, LpVolume> = {
  "ec-site": {
    "chapters": 18,
    "chars": 421855,
    "codeBlocks": 340,
    "hours": 56
  },
  "task-app": {
    "chapters": 17,
    "chars": 462883,
    "codeBlocks": 394,
    "hours": 67
  },
  "ai-chat": {
    "chapters": 18,
    "chars": 426874,
    "codeBlocks": 465,
    "hours": 57
  },
  "bi-dashboard": {
    "chapters": 19,
    "chars": 339522,
    "codeBlocks": 370,
    "hours": 82
  }
};
